import { Helmet } from "react-helmet-async";
import "./TestHomeTokens.css";
import TestHeroBanner from "./components/TestHeroBanner";
import TestPromoCards from "./components/TestPromoCards";
import TestWhyESBD from "./components/TestWhyESBD";
import TestInDemandProgrammes from "./components/TestInDemandProgrammes";
import TestAccreditationFaculties from "./components/TestAccreditationFaculties";
import TestLatestNews from "./components/TestLatestNews";

export default function TestHomePage() {
  return (
    <div className="th-page">
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&family=DM+Sans:wght@300;400;500;600;700&family=DM+Serif+Display:ital@0;1&family=Outfit:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <TestHeroBanner />
      <TestPromoCards />
      <TestWhyESBD />
      <TestInDemandProgrammes />
      <TestAccreditationFaculties />
      <TestLatestNews />
    </div>
  );
}
